import {defineStore} from 'pinia'
import {surveyConfig, valuesAndOptions} from '@/scripts/survey_config'
const createSurveyData = () => {
    const data = {
        name: '',
        phone: '',
        address: {},
        standort: {
            // init empty!
            // id: null,
            // name: null,
        },
        objekttyp: '',
        unterkunfts_typ: '',
        lokal_typ: '',
        besonderes_gebaeude: '',
        objektname: '',
        weitere_unterkuenfte: {
            select: '',

            ferienhaeuser: {
                checked: false,
                count: "1",
                anderer_standort: '',
                andere_orga: '',
                orga_name: '',
            },
            'schwimmende-unterkuenfte': {
                checked: false,
                count: "1",
                anderer_standort: '',
                andere_orga: '',
                orga_name: '',
            },
            ferienwohnungen: {
                checked: false,
                count: "1",
                anderer_standort: '',
                andere_orga: '',
                orga_name: '',
            },
            hotels: {
                checked: false,
                count: "1",
                anderer_standort: '',
                andere_orga: '',
                orga_name: '',
            },
            pensionen: {
                checked: false,
                count: "1",
                anderer_standort: '',
                andere_orga: '',
                orga_name: '',
            },
            hostels: {
                checked: false,
                count: "1",
                anderer_standort: '',
                andere_orga: '',
                orga_name: '',
            },
            familienferienstaetten: {
                checked: false,
                count: "1",
                anderer_standort: '',
                andere_orga: '',
                orga_name: '',
            },
            seminarhaeuser: {
                checked: false,
                count: "1",
                anderer_standort: '',
                andere_orga: '',
                orga_name: '',
            },
            jugendherberge: {
                checked: false,
                count: "1",
                anderer_standort: '',
                andere_orga: '',
                orga_name: '',
            },
        },
        zusatzobjekte: {
            select: '',
        },
        urlaubsarten: [],
        freizeitanbieter: '',
        freizeitanbieter_weitere: [],
        veranstaltung: {
            kategorie: '',
            terminart: '',
            termin: '',
            endtermin: '',
            uhrzeit: null,
            inhaber: '',
            ort_name: '',
            ort_typ: ''
        },
        kunst_kultur: {
            kategorie: '',
        },
        selbstbeschreibung: '',
    }
    data.zusatzunterkunft = JSON.parse(JSON.stringify(data.weitere_unterkuenfte))
    valuesAndOptions.zusatzobjekte.forEach(value => {
        data.zusatzobjekte[value.key] = {
            checked: false,
            public: false,
            name: '',
        }
    })

    return data
}

export const useSurveyStore = defineStore('survey', {
    // a function that returns a fresh state
    state: () => ({
            currentConfig: surveyConfig.personal_data,
            currentStep: 0,
            passedSteps: null, // used for outro-page-dot-nav
            osm_data: null,
            createdObject: null,
            additionalObjects: [],
            createdClients: [],
            data: createSurveyData(),
        }),
    // optional getters
    getters: {},
    // optional actions
    actions: {
        reset() {
            this.currentConfig = surveyConfig.personal_data
            this.currentStep = 0
            this.passedSteps = null
            this.osm_data = null
            this.createdObject = null
            this.additionalObjects = []
            this.createdClients = []
            this.data = createSurveyData()
        },
        setCreatedObject(object) {
            this.createdObject = object
        },
        setCreatedObjects(object, additionalObjects = [], clients = []) {
            this.createdObject = object
            this.additionalObjects = Array.isArray(additionalObjects) ? additionalObjects : []
            this.createdClients = Array.isArray(clients) ? clients : []
        },
        setCurrentConfig(name) {
            this.currentConfig = surveyConfig[name]
            if (typeof this.currentConfig.steps !== "undefined") {
                this.setSchema()
            }
        },
        setSchema() {
            if (this.currentConfig.steps) {
                this.currentConfig.schema = this.currentConfig.steps[this.currentStep]?.schema
                this.currentConfig.currentStep = this.currentConfig.steps[this.currentStep]
            } else {
                // submit ...
                this.currentConfig.schema = null
                this.currentConfig.currentStep = null
            }
        },

// mergeSchema(...schemas) {
//     const [first, ...rest] = schemas;
//     return rest.reduce(
//         (mergedSchemas, schema) => mergedSchemas.concat(schema),
//         first
//     );
// }
    },
})
